function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
export default function HeadTags(_ref) {
  var {
    pageInfo: {
      title,
      description
    },
    themeConfig: {
      headTags: {
        metas,
        links,
        scripts,
        base
      }
    }
  } = _ref;
  React.useEffect(() => {
    var head = document.querySelector('head');
    scripts.forEach(script => {
      var scriptElement = document.createElement('script');
      Object.keys(script).forEach(key => {
        if (script[key]) {
          scriptElement[key] = script[key];
        }
      });
      head.appendChild(scriptElement);
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  }), metas.map((meta, index) => /*#__PURE__*/React.createElement("meta", _extends({
    key: index
  }, meta))), links.map((link, index) => /*#__PURE__*/React.createElement("link", _extends({
    key: index
  }, link))), scripts.map((script, index) => /*#__PURE__*/React.createElement("script", _extends({
    key: index
  }, script))), base && /*#__PURE__*/React.createElement("base", base));
}
HeadTags.propTypes = {
  pageInfo: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired,
  themeConfig: PropTypes.shape({
    headTags: PropTypes.shape({
      metas: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
        charSet: PropTypes.string,
        httpEquiv: PropTypes.string,
        property: PropTypes.string,
        itemProp: PropTypes.string,
        itemType: PropTypes.string,
        itemID: PropTypes.string,
        lang: PropTypes.string
      })),
      links: PropTypes.arrayOf(PropTypes.shape({
        rel: PropTypes.string,
        href: PropTypes.string,
        sizes: PropTypes.string,
        type: PropTypes.string,
        hrefLang: PropTypes.string,
        media: PropTypes.string,
        title: PropTypes.string,
        as: PropTypes.string,
        crossOrigin: PropTypes.string,
        integrity: PropTypes.string,
        referrerPolicy: PropTypes.string
      })),
      scripts: PropTypes.arrayOf(PropTypes.shape({
        src: PropTypes.string,
        type: PropTypes.string,
        async: PropTypes.bool,
        defer: PropTypes.bool,
        crossOrigin: PropTypes.string,
        integrity: PropTypes.string,
        noModule: PropTypes.bool,
        nonce: PropTypes.string
      })),
      base: PropTypes.shape({
        href: PropTypes.string,
        target: PropTypes.string
      })
    })
  })
};
HeadTags.defaultProps = {
  themeConfig: {
    headTags: {
      metas: [],
      links: [],
      scripts: [],
      base: undefined
    }
  }
};
;
export var query = "\n  query query {\n    pageInfo {\n      title\n      description\n    }\n    themeConfig {\n      headTags {\n        metas {\n          name\n          content\n          charSet\n          httpEquiv\n          property\n          itemProp\n          itemType\n          itemID\n          lang\n        }\n        links {\n          rel\n          href\n          sizes\n          type\n          hrefLang\n          media\n          title\n          as\n          crossOrigin\n          integrity\n          referrerPolicy\n        }\n        scripts {\n          src\n          type\n          async\n          defer\n          crossOrigin\n          integrity\n          noModule\n          nonce\n        }\n        base {\n          href\n          target\n        }\n      }\n    }\n  }\n";